import { styled } from '@withjoy/joykit';

export const FlexCenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

export const Form = styled.form`
  display: flex;
  justify-content: center;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f8f8f6;
  padding: 3rem;
  border-radius: 10px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 8px;
`;

export const ErrorText = styled.p`
  color: #da505d;
  font-size: 13px;
  text-align: center;
`;
